import React, { FunctionComponent, lazy } from 'react';
import { Redirect } from 'react-router';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import RootState from 'ducks/RootState';
import { Feature } from 'ducks/merchantDucks/user/types';

import Rules from 'restrictions/roles/constants/rules';
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';

// components
import ContentWithSidenav from 'components/ContentWithSidenav/ContentWithSidenav';
import { SidenavLink } from 'components/ContentWithSidenav/Sidenav';
import RestrictedRoute from 'restrictions/routes/RestrictedRoute';

const AccountDetailsContent = lazy(() => import('../AccountDetails/containers/Account'));
const Password = lazy(() => import('../PasswordManagement/Password'));
const Organisation = lazy(() => import('../OrganisationDetails/containers/Organisation'));

const links: Array<SidenavLink> = [
  {
    label: 'Basic details',
    path: '',
    tag: 'basic_details',
  },
  {
    label: 'Organization',
    path: '/organisation',
    tag: 'organisation,',
  },
  {
    label: 'Password management',
    path: '/password',
    tag: 'password_management',
  },
];

const AccountDetails: FunctionComponent = () => {
  const { path } = useRouteMatch();
  const { hasRule } = useRestrictionRules();
  const features = useSelector((state: RootState) => state.auth.features);

  const organisationFeatureEnabled =
    features.some(({ name, enabled }: Feature) => name === 'Organisation' && enabled) &&
    !hasRule(Rules.DISABLE_ORGANISATION_SECTION);
  const renderLinks = organisationFeatureEnabled ? links : links.filter((x) => x.path !== '/organisation');

  return (
    <>
      <ContentWithSidenav links={renderLinks}>
        <Switch>
          <Route path={`${path}/password`}>
            <Password />
          </Route>
          <RestrictedRoute
            isRestricted={!organisationFeatureEnabled}
            path={`${path}/organisation`}
            component={Organisation}
          />
          <Route path={`${path}`}>
            <AccountDetailsContent />
          </Route>
          <Redirect to={`${path}`} />
        </Switch>
      </ContentWithSidenav>
    </>
  );
};

export default AccountDetails;
